/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { DraggableDirective } from "../../directives/draggable.directive";
import { Component, OnInit, ViewChild, EventEmitter, Input, OnDestroy } from '@angular/core';

import { Subscription } from "rxjs";

import { ObjectInstance } from "../../models/object-instance";
import { MainDisplayParameter } from "./main-display-parameter";
import { ImageService } from "app/services/image.service";


declare var $: any;


@Component({
  selector: 'app-person-locate-popup',
  templateUrl: './person-popup-dialog.component.html'
})
export class PersonPopupDialogComponent implements OnInit, OnDestroy {

  //Emitter used to hide the popup from the Parent.  Needs to be done inside here so that the drag directive can be reset
  @Input()
  callHideEmitter: EventEmitter<boolean>;

  //User whose information is being displayed in the popup
  @Input()
  person: ObjectInstance;
  mainDisplayParameters: MainDisplayParameter[];

  //Unique ID to give the popup.  Parent references it when showing the dialog
  @Input()
  dialogId: string;

  @Input()
  popupInModal = false;

  //Draggable Directive added to that the popup is draggable.  Referenced so that it can be reset when the popup is hidden
  @ViewChild(DraggableDirective) mDraggableDirective;

  //Subscription to the "hide" events from the Parent
  mHideSubscription: Subscription;


  constructor(
    private mImageService: ImageService
  ) { }


  ngOnInit(): void {
    if (this.callHideEmitter != null) {
      this.mHideSubscription = this.callHideEmitter.subscribe(value => {
        this.hide();
      });
    }

    this.mainDisplayParameters = MainDisplayParameter.getDisplayParameters(this.person);
  }

  ngOnDestroy(): void {
    if (this.mHideSubscription != null) {
      this.mHideSubscription.unsubscribe();
      this.mHideSubscription = null;
    }
  }


  public async show(): Promise<void> {
    console.log("Show object instance " + this.person.id);
    $("#" + this.dialogId).show();
  }

  public hide(): void {
    $("#" + this.dialogId).hide();
    this.mDraggableDirective.reset();
  }


  getIdForDialogHeader(): string {
    return this.dialogId + "_header";
  }

  getPathForPersonImage(): string {
    return this.mImageService.getImageSourceForObjectInstance(this.person);
  }

  getPathForPersonIcon(): string {
    return this.mImageService.getIconSourceForObjectInstance(this.person);
  }

  getPhoneNumber(): string {
    const datum = this.person.data.find(d => d.property.property == 'phone');
    return datum != null ? datum.value : "";
  }

  getCellNumber(): string {
    const datum = this.person.data.find(d => d.property.property == 'cell');
    return datum != null ? datum.value : "";
  }

  getEmail(): string {
    const datum = this.person.data.find(d => d.property.property == 'email');
    return datum != null ? datum.value : "";
  }

}
